
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import {
  AuthProvider,
  useAuth,
} from './modules/auth/context/AuthContext';

import LoginPage from './modules/auth/pages/LoginPage';
import ProtectedRoute from './app/ProtectedRoute';
import AdminLayout from './modules/admin/pages/AdminLayout';

import UserLayout from './modules/user/pages/UserLayout';
import UserDashboard from './modules/user/pages/UserDashboard';
import ProductsPage from './modules/user/pages/ProductsPage';
import CreateProductPage from './modules/user/pages/CreateProductPage';
import EditProductPage from './modules/user/pages/EditProductPage';

// Batches pages
import BatchesPage from './modules/user/pages/BatchesPage';
import CreateBatchPage from './modules/user/pages/CreateBatchPage';

// Invoice pages
import InvoicesPage from './modules/user/pages/InvoicesPage';
import CreateInvoicePage from './modules/user/pages/CreateInvoicePage';
import InvoiceDetailsPage from './modules/user/pages/InvoiceDetailsPage';

// Stock page
import StockPage from './modules/user/pages/StockPage';

function HomeRedirect() {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Navigate
      to={user?.role === 'super_admin' ? '/admin' : '/user'}
      replace
    />
  );
}

function NotFound() {
  return (
    <main style={{ padding: 32 }}>
      <h1>404 - Page not found</h1>
      <a href="/">Return home</a>
    </main>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Super Admin Routes — unchanged */}
      <Route
        element={
          <ProtectedRoute allowedRoles={['super_admin']} />
        }
      >
        <Route path="/admin/*" element={<AdminLayout />} />
      </Route>

      {/* Distributor Routes */}
      <Route
        path="/user"
        element={
          <ProtectedRoute allowedRoles={['distributor']} />
        }
      >
        <Route element={<UserLayout />}>
          <Route index element={<UserDashboard />} />

          {/* Products Routes — unchanged */}
          <Route
            path="products"
            element={<ProductsPage />}
          />

          <Route
            path="products/create"
            element={<CreateProductPage />}
          />

          <Route
            path="products/:productId/edit"
            element={<EditProductPage />}
          />

          {/* Batches Routes — unchanged */}
          <Route
            path="batches"
            element={<BatchesPage />}
          />

          <Route
            path="batches/create"
            element={<CreateBatchPage />}
          />

          {/* Invoice Routes — unchanged */}
          <Route
            path="invoices"
            element={<InvoicesPage />}
          />

          <Route
            path="invoices/create"
            element={<CreateInvoicePage />}
          />

          <Route
            path="invoices/:invoiceNumber"
            element={<InvoiceDetailsPage />}
          />

          {/* Stock Route */}
          <Route
            path="stock"
            element={<StockPage />}
          />
        </Route>
      </Route>

      <Route path="/" element={<HomeRedirect />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
